<!--
 * @Description: 上传文件图标组件
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <span class="upload-icon-container margin-r-m">
    <qf-icon-pdf v-if="fileType('pdf')" class="upload-icon" />
    <qf-icon-ppt v-else-if="fileType('ppt')" class="upload-icon" />
    <qf-icon-excel v-else-if="fileType('xlsx')" class="upload-icon" />
    <qf-icon-word v-else-if="fileType('docs')" class="upload-icon" />
    <qf-icon-zip v-else-if="fileType('zip')" class="upload-icon" />
    <qf-icon-img v-else-if="fileType('img') || fileType('unableImg')" class="upload-icon" />
    <qf-icon-video v-else-if="fileType('video') || fileType('unableVideo')" class="upload-icon" />
    <!-- 不可预览类型 -->
    <qf-icon-other v-else class="upload-icon" />
  </span>
</template>
<script setup>
import { computed } from 'vue';

import useXlUpload from '@/hooks/upload';
const { getFileType } = useXlUpload();

const fileType = (type) => {
  return getFileType(getFileItem.value?.name || '', type);
};

const props = defineProps({
  activeFile: {
    //当前文件
    type: Object,
    default: () => {}
  }
});
const getFileItem = computed(() => {
  return props.activeFile;
});
</script>

<style lang="less">
@import './index.less';
</style>
